export enum Statuses {
  READY = "Ready",
  ASSIGNED = "Assigned",
  INPROGRESS = "InProgress",
  SUSPENDED = "Suspended",
  COMPLETE = "Complete",
  CANCELLED = "Cancelled",
}

export enum StatusesIn360 {
  READY = "Ready",
  ASSIGNED = "Assigned",
  COMPLETE = "Complete",
}
